var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './PopoverModal.scss';
import classNames from 'classnames';
import { getClosestButton } from '@lib/popups';
import React, { useEffect, useState } from 'react';
import { SonarModal } from './SonarModal';
function calculatePopoverPosition(position, triggerButton) {
    const { bottom, left, right, top } = triggerButton.getBoundingClientRect();
    if (position === 'bottomLeft') {
        return {
            left,
            top: bottom + 3
        };
    }
    if (position === 'bottomRight') {
        return {
            right: window.innerWidth - right,
            top: bottom + 3
        };
    }
    if (position === 'topLeft') {
        return {
            bottom: top - 3,
            left
        };
    }
    if (position === 'topRight') {
        return {
            bottom: top - 3,
            right: window.innerWidth - right
        };
    }
    return {};
}
export const PopoverModal = (_a) => {
    var { className, open, popoverTarget, popoverPosition = 'bottomLeft', style } = _a, rest = __rest(_a, ["className", "open", "popoverTarget", "popoverPosition", "style"]);
    const [customStyle, setCustomStyle] = useState(style !== null && style !== void 0 ? style : {});
    useEffect(() => {
        const target = popoverTarget.current;
        if (open && target) {
            setCustomStyle((current) => {
                var _a;
                return (Object.assign(Object.assign({}, current), calculatePopoverPosition(popoverPosition, (_a = getClosestButton(target)) !== null && _a !== void 0 ? _a : target)));
            });
        }
    }, [open, popoverPosition, popoverTarget]);
    const modalClassNames = classNames('sonar-modal-popover', {
        'sonar-modal-popover-bottom-left': popoverPosition === 'bottomLeft',
        'sonar-modal-popover-bottom-right': popoverPosition === 'bottomRight',
        'sonar-modal-popover-top-left': popoverPosition === 'topLeft',
        'sonar-modal-popover-top-right': popoverPosition === 'topRight'
    }, 'flex-inputs', className);
    return React.createElement(SonarModal, Object.assign({}, rest, { className: modalClassNames, open: open, style: customStyle }));
};
